<script>
	import Gallery from './Gallery.svelte';
  export let data;
  let photosCount
  if(data.photos[1]){
    photosCount = data.photos[1];
  } else {
    photosCount = 1;
  }
</script>
{#if photosCount === 1}
  <div><img src="photos/id-{data.id}/1.jpg" /></div>
{:else if photosCount > 1}
  <Gallery gap="20" maxColumnWidth="400">
    {#each new Array(photosCount) as photo, i}
      <img src="photos/id-{data.id}/{i+1}.jpg" />
    {/each}
  </Gallery>
{/if}

<style>
  div {
    margin-top: 40px;
    max-width: 70ex;
  }
  img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
</style>